<template>
  <div class="font-bebas text-5xl">
    <slot></slot>
  </div>
</template>
